

//通用
import { Data as AuthContent } from '../authentication/index'
import { Data as ChangeLogContent } from '../changelog/index'

// 共用
// import { List as SocketContent } from '../spot/websocket/index'
import { Data as BasicContent } from '../spot/api/basic/index'

import { Data as TradeOrderContent } from './api/trade/index'
import Introduce from './1_introduce.json'


import { Data as QandAContent } from '../q&a/index'
const QandA = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/q&a`,
  "name": "Frequently Asked Questions",
  "content": QandAContent
}

const ROOT_MODULE = "en-us/standard"

// export const Socket = {
//   "module": ROOT_MODULE,
//   "path": `/${ROOT_MODULE}/socket`,
//   "name": "Socket API Reference",
//   "children": SocketContent
// }


const ChangeLog = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/changelog`,
  "name": "Change Log",
  "content": ChangeLogContent
}
const TradeOrder = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/contract-interface.html`,
  "name": "Standard Contract Interface",
  "content": TradeOrderContent
}
const Authentication = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/authentication.html`,
  "name": "Authentication",
  "content": AuthContent
}
const Basic = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/base-info.html`,
  "name": "General Info",
  "content": BasicContent
}


export const standardConfig = [
  Introduce,
  ChangeLog,
  QandA,
  Basic,
  Authentication,
  TradeOrder,
]


// WEBPACK FOOTER //
// ./src/config/en-US/standard/index.js